<template>
  <v-card flat>
    <v-card-subtitle>
      <v-icon left>{{ settingsIcon }}</v-icon>
      <span
        class="font-weight-bold">{{ $vuetify.lang.t(`$vuetify.map.driverSettings.iconedLabels.${title}`) }}</span>
    </v-card-subtitle>
    <v-card-text class="px-1">
      <v-row class="mx-auto fill-height" no-gutters v-if="detection">
        <v-col cols="12" md="6">
          <v-switch class="mx-10 text-center"
                    :label="$vuetify.lang.t(`$vuetify.map.driverSettings.labels.${detection}`)"
                    :placeholder="getPlaceholder(detection)"
                    :messages="isDebug ? detection : ''"
                    v-model="settings[detection]">
            <v-checkbox v-show="isFineTuning" class="shrink mt-0" slot="prepend"
                        v-model="fineTuningSettings[detection]"></v-checkbox>
          </v-switch>
        </v-col>
      </v-row>
      <v-row class="mx-auto px-md-5" justify="start" align-content="start" align="start" no-gutters>
        <template v-for="entry in fields">
          <v-col cols="12" :md="mdCols" class="px-0 " :key="entry.field" align-self="end"
                 :class="entry.hasOwnProperty('css') ? entry.css : ''" v-if="!entry.hasOwnProperty('show') || entry.show">
            <template v-if="entry.hasOwnProperty('type') && entry.type === 'switch'">
              <v-switch
                :label="$vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.field}`)"
                :placeholder="getPlaceholder(entry.field)"
                :messages="isDebug ? entry.field : ''"
                v-model.number="settings[entry.field]">
                <v-checkbox v-show="isFineTuning" slot="prepend" class="shrink mt-0" dense
                            hide-details v-model="fineTuningSettings[entry.field]"></v-checkbox>
              </v-switch>
            </template>
            <template v-else-if="entry.hasOwnProperty('type') && entry.type === 'slider'">
              <v-card-subtitle class="mb-5" :class="entry.hasOwnProperty('css') ? entry.css : ''" >{{ $vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.field}`) }}
              </v-card-subtitle>
              <v-slider
                thumb-label="always" :min="entry.min" :max="entry.max"
                class="slider"
                :placeholder="getPlaceholder(entry.field)"
                :messages="isDebug ? entry.field : ''"
                v-model.number="settings[entry.field]">
                <v-checkbox v-show="isFineTuning" class="shrink mt-0" slot="prepend"
                            v-model="fineTuningSettings[entry.field]"></v-checkbox>
              </v-slider>
            </template>
            <template v-else>
              <v-card-text class="mx-n2 caption">
                {{ $vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.field}`) }}
              </v-card-text>
              <v-text-field
                :placeholder="getPlaceholder(entry.field)"
                class="mt-n8"
                type="number" :step="entry.hasOwnProperty('step') ? entry.step : 1"
                :messages="isDebug ? entry.field : ''"
                :rules="entry.hasOwnProperty('rules') ? entry.rules : timeRules"
                :disabled="entry.hasOwnProperty('canBeDisabled') && entry.canBeDisabled && entry.disableCondition(settings)"
                v-model.number="settings[entry.field]">
                <v-checkbox v-show="isFineTuning" class="shrink mt-0" slot="prepend"
                            v-model="fineTuningSettings[entry.field]"></v-checkbox>
              </v-text-field>
            </template>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import driverSettingsMixin from '../../../mixins/driverSettingsMixin'
import { mdiCogs } from '@mdi/js'
import { timeRules } from '../../../utils/formRules'

const settingsIcon = mdiCogs

export default {
  name: 'generalSettings',
  mixins: [driverSettingsMixin],
  props: {
    detection: String,
    title: String,
    fields: Array,
    mdCols: {
      type: Number,
      default: 6
    },
    isDebug: Boolean
  },
  data: () => ({
    settingsIcon: settingsIcon
  }),
  created () {
    this['timeRules'] = timeRules
  }
}
</script>

<style scoped>

</style>
